/* eslint-disable camelcase, no-undef */
__webpack_public_path__ = window.HELIOS.publicPath;
